import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {
    backgroundColor,
    borderRadius,
    calculateRemSize,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    maxWidth,
    minWidth,
    mt,
    onDesktop,
    ph,
    Size
} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {useIconOptionsFromVariant} from "../hooks/use_icon_options_from_variant";
import {PictogramType} from "../types/PictogramType";
import {getLabeledIconsFromVariant} from "../utils/get_labeled_icons_from_variant";
import {IconWithElement} from "./IconWithElement";

interface IProps {
    variant: PictogramType;
    componentsMobileGap?: Size;
    componentsDesktopGap?: Size;
}

export const CreditCalculatorPictograms = (props: IProps) => {
    const {componentsMobileGap = 6, componentsDesktopGap = 6} = props;
    const iconOptions = useIconOptionsFromVariant(props.variant);
    const icons = getLabeledIconsFromVariant(props.variant);

    return (
        <div css={pictogramsWrapper}>
            <IconsContainer componentsDesktopGap={componentsDesktopGap} componentsMobileGap={componentsMobileGap}>
                {props.variant === PictogramType.LABELED_ICON &&
                    icons.map((el, index) => (
                        <IconWithElement key={index} icon={el.icon} iconProps={iconOptions} containerStyle={iconWithElementLabeledStyle}>
                            <Text variant="body_copy_0" as="p" align="center">
                                {el.label}
                            </Text>
                        </IconWithElement>
                    ))}
                {props.variant === PictogramType.BOX &&
                    icons.map((el, index) => (
                        <div key={index} css={iconBox}>
                            <div css={iconPositioner}>
                                <IconWithElement icon={el.icon} iconProps={iconOptions} containerStyle={iconWithElementBoxStyle}>
                                    <Text variant="body_copy_0" as="p" align="center" css={[ph(1.5), onDesktop(ph(4))]}>
                                        {el.label}
                                    </Text>
                                </IconWithElement>
                            </div>
                        </div>
                    ))}
            </IconsContainer>
        </div>
    );
};

const pictogramsWrapper = css`
    ${flex("center", "center")};
    ${flexDirection("column")};
`;

const IconsContainer = styled.div<{componentsMobileGap: Size; componentsDesktopGap: Size}>`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    row-gap: ${(props) => calculateRemSize(props.componentsMobileGap)};

    ${onDesktop(css`
        ${flexDirection("row")};
        column-gap: ${calculateRemSize(3.5)};
    `)};

    @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
        column-gap: ${(props) => calculateRemSize(props.componentsDesktopGap)};
    }
`;

const iconWithElementStyle = css`
    width: 232px;
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${maxWidth(calculateRemSize(25))};

    ${onDesktop(css`
        ${maxWidth("unset")};
    `)};
`;

const iconWithElementLabeledStyle = css`
    ${iconWithElementStyle};
    gap: ${calculateRemSize(2)};
`;

const iconWithElementBoxStyle = css`
    ${iconWithElementStyle};
    gap: ${calculateRemSize(1)};

    ${onDesktop(css`
        gap: ${calculateRemSize(2)};
    `)};
`;

const iconBox = (theme: Theme) => css`
    ${backgroundColor(theme.colors.primary)};
    height: ${calculateRemSize(16)};
    ${borderRadius(2)};
    ${mt(6)};

    ${onDesktop(css`
        height: ${calculateRemSize(21)};
        ${minWidth("230px")};
    `)};
`;
const iconPositioner = css`
    transform: translateY(-50px);
`;
import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {
    backgroundColor,
    borderRadius,
    calculateRemSize,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    maxWidth,
    minWidth,
    mt,
    onDesktop,
    ph,
    Size
} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {useIconOptionsFromVariant} from "../hooks/use_icon_options_from_variant";
import {PictogramType} from "../types/PictogramType";
import {getLabeledIconsFromVariant} from "../utils/get_labeled_icons_from_variant";
import {IconWithElement} from "./IconWithElement";

interface IProps {
    variant: PictogramType;
    componentsMobileGap?: Size;
    componentsDesktopGap?: Size;
}

export const CreditCalculatorPictograms = (props: IProps) => {
    const {componentsMobileGap = 6, componentsDesktopGap = 6} = props;
    const iconOptions = useIconOptionsFromVariant(props.variant);
    const icons = getLabeledIconsFromVariant(props.variant);

    return (
        <div css={pictogramsWrapper}>
            <IconsContainer componentsDesktopGap={componentsDesktopGap} componentsMobileGap={componentsMobileGap}>
                {props.variant === PictogramType.LABELED_ICON &&
                    icons.map((el, index) => (
                        <IconWithElement key={index} icon={el.icon} iconProps={iconOptions} containerStyle={iconWithElementLabeledStyle}>
                            <Text variant="body_copy_0" as="p" align="center">
                                {el.label}
                            </Text>
                        </IconWithElement>
                    ))}
                {props.variant === PictogramType.BOX &&
                    icons.map((el, index) => (
                        <div key={index} css={iconBox}>
                            <div css={iconPositioner}>
                                <IconWithElement icon={el.icon} iconProps={iconOptions} containerStyle={iconWithElementBoxStyle}>
                                    <Text variant="body_copy_0" as="p" align="center" css={[ph(1.5), onDesktop(ph(4))]}>
                                        {el.label}
                                    </Text>
                                </IconWithElement>
                            </div>
                        </div>
                    ))}
            </IconsContainer>
        </div>
    );
};

const pictogramsWrapper = css`
    ${flex("center", "center")};
    ${flexDirection("column")};
`;

const IconsContainer = styled.div<{componentsMobileGap: Size; componentsDesktopGap: Size}>`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    row-gap: ${(props) => calculateRemSize(props.componentsMobileGap)};

    ${onDesktop(css`
        ${flexDirection("row")};
        column-gap: ${calculateRemSize(3.5)};
    `)};

    @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
        column-gap: ${(props) => calculateRemSize(props.componentsDesktopGap)};
    }
`;

const iconWithElementStyle = css`
    width: 232px;
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${maxWidth(calculateRemSize(25))};

    ${onDesktop(css`
        ${maxWidth("unset")};
    `)};
`;

const iconWithElementLabeledStyle = css`
    ${iconWithElementStyle};
    gap: ${calculateRemSize(2)};
`;

const iconWithElementBoxStyle = css`
    ${iconWithElementStyle};
    gap: ${calculateRemSize(1)};

    ${onDesktop(css`
        gap: ${calculateRemSize(2)};
    `)};
`;

const iconBox = (theme: Theme) => css`
    ${backgroundColor(theme.colors.primary)};
    height: ${calculateRemSize(16)};
    ${borderRadius(2)};
    ${mt(6)};

    ${onDesktop(css`
        height: ${calculateRemSize(21)};
        ${minWidth("230px")};
    `)};
`;
const iconPositioner = css`
    transform: translateY(-50px);
`;
